// Integer helpers for the pure sim. Every input and output is a safe integer
// (|x| < 2^53), so results are exact and identical on every JavaScript engine.
// M3 adds mulDiv, clamp, lerpInt and friends here.

/** Floor division for integers: floorDiv(-7, 2) = -4. `b` must be a positive integer. */
export function floorDiv(a: number, b: number): number {
  const m = ((a % b) + b) % b;
  return (a - m) / b;
}

/** Absolute value for integers (no float involved; kept here so call sites read as int math). */
export function absInt(a: number): number {
  return a < 0 ? -a : a;
}
